
// ROUTES
export const ROUTES = {
    DASHBOARD: "/dashboard",
    NEWDASHBOARD: "/NewDashboard",
    PROFILE: "/profile",
    PREFERENCES: "/preferences",
    LOGIN: "/login",
  };
  
  // Role-based route access
  export const ROUTE_ACCESS = {
    ADMIN_ONLY: [ROUTES.PREFERENCES],
    USER_ONLY: [ROUTES.PROFILE],
  };
  
  
 // Roles from JWT claims
  export const ROLES = {
    ADMIN: "IsAdmin",
    SUPERADMIN: "IsSuperAdmin",
  };
 
  
  // API ENDPOINTS
  export const API = {
    LANGUAGE_GET_LIST: "/LanguageManagement/GetLanguageInfo",
    EMPLOYEE_GET_LIST: "/EmployeeManagement/GetEmployeeList",
    REPORTS_GET_DEVICE_LOG: "/Report/deviceInfoLogs",
    REPORTS_GET_VALIDATION_LOG: "/Report/validationLogs",
    SETTINGS: "/settings",
    PROFILE: "/profile",
  };
  
  // LOCAL STORAGE KEYS
  export const STORAGE_KEYS = {
    THEME_MODE: "app-theme",
    USER_PREFS: "user-prefs",
  };
  
  // APP LABELS
  export const APP = {
    NAME: "AMS Admin Portal",
    FOOTER_TEXT: "© 2024 My Admin Portal. All rights reserved.",
  };

  // ENV CONFIG
  export const CONFIG = {
    ENV: process.env.REACT_APP_ENV || "development",
    API_BASE_URL: process.env.REACT_APP_API_BASE_URL || "http://localhost:3001/api",
    IS_DEV: process.env.REACT_APP_ENV === "development",
    HMACKEY: process.env.REACT_APP_HMAC_KEY || "NDUwRDk5NDUtN0E3RC00MzhBLTgzNDgtQTMwOTM0OEE5QjVC",
  };
  
  